import { createBrowserHistory } from 'history';

const deliHistory = createBrowserHistory();
export default deliHistory;
